// API 기본 URL 상수
const API_BASE_URL = "https://contract.tirebank.kr";

export const sendContractSMS = async (
  contractId,
  participants,
  contractInfo,
  contractNumber = null
) => {
  try {
    // KAKAO 타입으로 설정된 참여자만 필터링
    const kakaoParticipants = participants.filter(
      (p) => p.notifyType === "KAKAO"
    );
    let successCount = 0;

    for (const participant of kakaoParticipants) {
      try {
        // 현재 날짜를 YYYY-MM-DD 형식으로 변환
        const today = new Date();
        const contractDate = today.toISOString().split("T")[0];

        // 알림톡 요청 데이터 생성
        // - participantId 포함: 백엔드에서 needsResign 상태 확인 후 적절한 URL 자동 생성
        // - 토큰도 백엔드에서 자동 생성
        const kakaoAlertData = {
          participantId: participant.id, // 백엔드에서 needsResign 확인 및 토큰 생성용
          phoneNumber: participant.phoneNumber,
          name: participant.name,
          title: contractInfo?.title || "계약서 서명 요청",
          requester: contractInfo?.createdBy || "관리자",
          contractDate: contractDate,
          contractNumber: contractNumber,
          // url 제거: 백엔드에서 needsResign에 따라 자동 생성
        };

        // 알림톡 API 호출 (토큰 발급 + URL 생성 + 발송 모두 백엔드에서 처리)
        const response = await fetch(
          `${API_BASE_URL}/api/kakao-alert/contract-signature`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
            body: JSON.stringify(kakaoAlertData),
          }
        );

        if (!response.ok) {
          const errorText = await response.text();
          console.error("알림톡 발송 실패:", errorText);
          throw new Error(`알림톡 발송 실패 - ${participant.phoneNumber}`);
        }

        const result = await response.json();
        console.log(
          `알림톡 발송 성공 - ${participant.name}: needsResign=${result.needsResign}`
        );

        successCount++;
      } catch (participantError) {
        // 단일 참여자 처리 중 오류가 발생한 경우 기록하고 다음 참여자 계속 처리
        console.error(
          `참여자 처리 중 오류(${participant.phoneNumber}):`,
          participantError
        );
      }
    }

    return { success: true, smsCount: successCount };
  } catch (error) {
    console.error("알림톡 발송 중 오류:", error);
    return { success: false, error: error.message };
  }
};
